// extracted by mini-css-extract-plugin
export var category = "_iz-9";
export var categoryHeader = "_iz-e";
export var container = "_iz-0";
export var group = "_iz-a";
export var groupItems = "_iz-f";
export var groupSeparator = "_iz-j";
export var loading = "_iz-1";
export var noResults = "_iz-3";
export var placeholder = "_iz-2";
export var resultContent = "_iz-5";
export var resultIcon = "_iz-c";
export var resultItem = "_iz-g";
export var resultMeta = "_iz-8";
export var resultSubtitle = "_iz-7";
export var resultSuffix = "_iz-i";
export var resultTitle = "_iz-6";
export var resultsList = "_iz-4";
export var searchGroup = "_iz-d";
export var selected = "_iz-h";
export var subgroup = "_iz-b";